<template>
  <div id="contenedor-reportar-partida-editar-reportes-fisiccos">
    <v-alert
      type="info"
      text>
      {{ partida.concepto }}
    </v-alert>
    <v-form
      v-model="formularioValido"
      ref="reportarPartida">
      <v-row>
        <custom-text-field
          v-model.number="reportarPartida.avanceFisico"
          cols="12"
          md="4"
          label="Avance"
          prefix="%"
          min="0"
          max="100"
          step="0.01"
          @input="calcularAvancePonderado($event)"
          :rules="[reglas.avance]">
        </custom-text-field>
        <custom-text-field
          v-model.number="partida.ponderadoPartida"
          cols="12"
          md="4"
          label="Ponderado"
          prefix="%"
          readonly
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <custom-text-field
          v-model.number="reportarPartida.avancePonderado"
          cols="12"
          md="4"
          label="Av. Ponderado"
          prefix="%"
          readonly
          :rules="[mixReglas.requerido]">
        </custom-text-field>
        <custom-text-area
          v-model="reportarPartida.comentario"
          label="Comentarios (opcional)"
          rows="3"
          auto-grow>
        </custom-text-area>
        <v-col cols="12">
          <v-alert type="info">
            La fecha se habilita al agregar imágenes.
          </v-alert>
        </v-col>
        <DatePicker
          v-model="reportarPartida.fecha"
          label="Fecha (habilitar con imágenes)"
          :max="new Date().toISOString().substr(0, 10)"
          :disabled="imagenes.length === 0">
        </DatePicker>
      </v-row>
      <div id="contenedor-album-fotografico">
        <v-row>
          <template
            v-for="(imagen, index) in imagenes">
            <template>
              <v-col
                cols="auto"
                class="pa-1"
                :key="`img-${index}`">
                <v-img
                  :src="imagen"
                  height="180"
                  width="180"
                  contain
                  class="blue-grey darken-4">
                  <div class="contenedor-imagenes-remover-imagen">
                    <v-btn
                      small
                      icon
                      dark
                      @click="removerImagen(index)">
                      <v-icon>
                        mdi-close-circle
                      </v-icon>
                    </v-btn>
                  </div>
                </v-img>
              </v-col>
            </template>
          </template>
          <v-col
            cols="auto">
            <div
              class="contenedor-imagenes-agregar"
              @click="$refs.seleccionarAnexo.click()">
              <v-img
                src="@/assets/add-img-img.png"
                contain
                height="100"
                width="100">
              </v-img>
            </div>
          </v-col>
        </v-row>
      </div>
      <input
        type="file"
        ref="seleccionarAnexo"
        id="anexo"
        class="d-none"
        accept="image/jpeg, image/png, image/bmp"
        multiple
        @change="preCargarImagenes">
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextArea from '@/components/inputs/TextArea.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import {
  calcularAvancePonderado, limitarAvanceFisico, validarAvanceFisico,
} from './avanceFisico';

export default {
  name: 'ReportarPartidaEditarReportesFisicos',
  props: {
    partida: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomTextField,
    CustomTextArea,
    DatePicker,
  },
  data() {
    return {
      formularioValido: false,
      reglas: {
        avance: (value) => validarAvanceFisico(value)
          || 'El avance debe estar entre 0 y 100%, con hasta 2 decimales.',
      },
      enviandoFormulario: false,
      imagenes: [],
      reportarPartida: {
        idPartida: this.partida.id,
        avanceFisico: 0,
        ponderadoPartida: 0,
        avancePonderado: 0,
        comentario: '',
        fecha: null,
        imagenes: [],
      },
    };
  },
  mounted() {
    const este = this;
    este.reportarPartida.avanceFisico = limitarAvanceFisico(
      este.partida.reportado.avanceFisico,
    );
    este.reportarPartida.ponderadoPartida = este.partida.reportado.ponderadoPartida;
    este.calcularAvancePonderado(este.reportarPartida.avanceFisico);
    este.reportarPartida.comentario = este.partida.reportado.comentario;
    const fechaReportada = este.partida.reportado.fecha;
    este.reportarPartida.fecha = fechaReportada || new Date().toISOString().substr(0, 10);
    este.reportarPartida.imagenes = este.partida.reportado.imagenes;
    este.crearUrlDeLasImagenesSeleccionadas();
  },
  methods: {
    guardar() {
      if (!this.$refs.reportarPartida.validate()
        || !validarAvanceFisico(this.reportarPartida.avanceFisico)) return;
      this.calcularAvancePonderado(this.reportarPartida.avanceFisico);
      this.$emit('guardar', this.reportarPartida);
    },
    calcularAvancePonderado(avance = this.reportarPartida.avanceFisico) {
      this.reportarPartida.avancePonderado = calcularAvancePonderado(
        this.reportarPartida.ponderadoPartida, avance,
      );
    },
    preCargarImagenes() {
      const { imagenes } = this.reportarPartida;
      // get las fotos
      const fileInput = document.getElementById('anexo');
      imagenes.push(...fileInput.files);

      for (let i = 0; i < fileInput.files.length; i += 1) {
        const url = URL.createObjectURL(fileInput.files[i]);
        this.imagenes.push(url);
      }
    },
    crearUrlDeLasImagenesSeleccionadas() {
      const { imagenes } = this.reportarPartida;
      for (let i = 0; i < imagenes.length; i += 1) {
        if (typeof (imagenes[i]) === 'string') {
          const url = `${this.$urlFileServer}/${imagenes[i]}`;
          this.imagenes.push(url);
        } else {
          const url = URL.createObjectURL(imagenes[i]);
          this.imagenes.push(url);
        }
      }
    },
    removerImagen(index) {
      this.imagenes.splice(index, 1);
      this.reportarPartida.imagenes.splice(index, 1);
    },
    limpiarFormulario() {
      this.$refs.reportarPartida.reset();
      this.imagenes = [];
      this.reportarPartida.imagenes = [];
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
  watch: {
    partida: {
      handler() {
        this.reportarPartida.ponderadoPartida = this.partida.ponderadoPartida || 0;
        this.reportarPartida.avanceFisico = limitarAvanceFisico(
          this.partida.reportado.avanceFisico,
        );
        this.calcularAvancePonderado(this.reportarPartida.avanceFisico);
        this.reportarPartida.comentario = this.partida.reportado.comentario;
        const fechaReportada = this.partida.reportado.fecha;
        this.reportarPartida.fecha = fechaReportada || new Date().toISOString().substr(0, 10);
        this.reportarPartida.imagenes = this.partida.reportado.imagenes;
        this.crearUrlDeLasImagenesSeleccionadas();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.contenedor-imagenes-vista-previa {
  position: relative;
}
.contenedor-imagenes-remover-imagen {
  position: absolute;
  top: 5px;
  right: 5px;
}
.contenedor-imagenes-agregar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ccc;
  height: 180px;
  width: 180px;
  padding: 1em;
  border-radius: .5rem;
  cursor: pointer;
}
.contenedor-imagenes-agregar:hover {
  border: 2px solid #ccc;
}
</style>
